var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4438 9.81382H4.15925L8.14915 13.6029C8.35023 13.7938 8.46321 14.0527 8.46321 14.3228C8.46321 14.5928 8.35023 14.8518 8.14915 15.0427C7.94816 15.2336 7.67556 15.3409 7.3913 15.3409C7.10705 15.3409 6.83444 15.2336 6.63346 15.0427L0.813686 9.51517C0.395437 9.11733 0.395437 8.47291 0.813686 8.07507L6.63346 2.5482C6.84284 2.34932 7.11678 2.25 7.39142 2.25C7.66607 2.25 7.94048 2.3491 8.14939 2.54797C8.35047 2.73888 8.46344 2.99786 8.46344 3.26791C8.46344 3.53795 8.35047 3.79693 8.14939 3.98784L4.15925 7.77733H17.4438C18.0297 7.78562 18.5 8.23907 18.5 8.79557C18.5 9.35208 18.0297 9.80552 17.4438 9.81382Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.e1d4639c0f0db22f9c4f53f1218d1ff6.svg";
export { ForwardRef as ReactComponent };